export function scrollToFirstError(resource, errors) {
  const firstFieldWithError = errors.find(specificError => specificError.source)?.source;
  let nodeToScrollTo;
  if (firstFieldWithError) {
    nodeToScrollTo = document.querySelector(`[data-element-semantic="meta-control"][data-resource-type="${resource.type()}"][data-attr-name="${firstFieldWithError}"][data-instance-id="${resource.instanceId()}"]`);
  }

  // If we can't scroll to the first DOM node with an error (perhaps the server error didn't specify a specific field, or maybe that field isn't being rendered), let's instead scroll to the error list
  if (!nodeToScrollTo) {
    nodeToScrollTo = document.querySelector(`[data-element-semantic="error-list"][data-resource-type="${resource.type()}"][data-instance-id="${resource.instanceId()}"]`);
  }
  // Only scroll if there is something to scroll to (it is possible for there to be no error list and no meta control!)
  if (nodeToScrollTo) {
    nodeToScrollTo.scrollIntoView({ behavior: 'smooth' });
  }
}

export function focusFirstErrorField(resource, errors) {
  const errorElements = errors.flatMap(({ source }) => Array.from(document.querySelectorAll(
    `[data-element-semantic="meta-control"][data-resource-type="${resource.type()}"][data-attr-name="${source}"][data-instance-id="${resource.instanceId()}"] input`,
  )));
  if (errorElements.length > 0) {
    errorElements[0].focus();
  }
}
